import React, { useEffect, useState } from 'react'
import Layout from '../Layout'
import { Box, Button, CircularProgress, Container, Grid, Paper, TextField, Typography, makeStyles } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select';
import CustomBreadcrumbs from '../Breadcrumb'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library'
import { addUser, editUser, getAllDepartments, getUserById } from '../../ReduxStore/MastertableSlice'
import { getVendorData } from '../../ReduxStore/VendorDataSlice'
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        maxWidth: 1100,
        // margin: '0 auto',
        paddingBlock: 30,
        marginTop: 10,
        marginBottom: 10
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formControl: {
        marginBottom: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(2),
    },
    lowPriority: {
        color: 'green',
    },
    mediumPriority: {
        color: 'yellow',
    },
    highPriority: {
        color: 'red',
    },
}));

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    control: (provided) => ({
        ...provided,
        minHeight: '54px',
        height: '54px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '54px',
        padding: '0 8px',
    }),
};

const AddUser = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const user_id = pathname[3]

    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' },
        { label: 'User Management', href: '/user-management' }
    ];
    const { response } = useSelector(state => state.vendor);

    const [postLoading, setPostLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [departments, setDepartment] = useState([]);
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [departmentOptions, setDepartmentOptions] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [isSupplierSelected, setIsSupplierSelected] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        UserName: '',
        email: '',
        phoneno: ''
    });

    const [phoneError, setPhoneError] = useState(""); // Error state for phone number

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Phone number validation
        if (name === "phoneno") {
            const phoneRegex = /^\d{10}$/; // Regex for exactly 10 digits
            if (!phoneRegex.test(value)) {
                setPhoneError("Phone number must be 10 digits.");
            } else {
                setPhoneError(""); // Clear error
            }
        }

        // Update form data
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // // Handle input changes
    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({
    //         ...formData,
    //         [name]: value,
    //     });
    // };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setPostLoading(true)

        // Build departments object based on selected department
        const departments = {};
        const departmentId = selectedDepartment?.value;
        const customerId = "af33f9117ecb4d8d8def84d6331eebd4";
        const designationId = "4702b44d85a249ffab51b0c2349e929d";

        if (selectedDepartment.label === "Administration") {
            departments[departmentId] = [customerId];
        } else if (selectedDepartment?.label === 'supplier' && selectedSupplier) {
            departments[departmentId] = [selectedSupplier.value];
        }

        const payload = {
            username: formData.UserName,
            name: formData.name,
            email: formData.email,
            phoneNo: formData.phoneno,
            customerId: customerId,
            designationId: designationId,
            departments: departments
        }

        if (user_id) {
            try {
                const action = dispatch(editUser({ data: payload, user_id: user_id }));
                const res = await action.unwrap();
                if (res.result) {
                    setPostLoading(false)
                    toast.success("User Edit Successfully!");
                    setTimeout(() => {
                        navigate("/user-management")
                    }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        } else {
            const payload = {
                username: formData.UserName,
                name: formData.name,
                email: formData.email,
                phoneNo: formData.phoneno,
                customerId: customerId,
                designationId: designationId,
                departments: departments,
                password: "sxdfghjklh",
                status:"active"
            }
            try {
                const action = dispatch(addUser(payload));
                const res = await action.unwrap();
                if (res.result) {
                    setPostLoading(false)
                    toast.success("User Added Successfully!");
                    setTimeout(() => {
                        navigate("/user-management")
                    }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        }
    };


    const getDepartments = async () => {
        try {
            const action = dispatch(getAllDepartments(`?customerID=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            console.log("check getDepartments", res.result)
            if (res.result) {
                setDepartment(res.result)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    const getUser = async () => {
        try {
            const action = dispatch(getUserById(`?userID=${user_id}`));
            const res = await action.unwrap();
            console.log("check USER", res.result)
            if (res.result && res.result.length > 0) {
                const user = res.result[0]; // Assuming you only need the first user in the array

                // Prefill the form data
                setFormData({
                    name: user.name || '',
                    UserName: user.username || '',
                    email: user.email || '',
                    phoneno: user.phoneNo || ''
                });

                // // Find the matching department option
                // const department = departmentOptions.find(
                //     (option) => option.value === user.departments
                // );

                // // Prefill the selected department
                // setSelectedDepartment(department || null); // Set to null if no match found
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchUser = async () => {
            await getUser();
            setLoading(false);
        };
        if (user_id) {
            fetchUser();
        }
    }, [user_id])


    useEffect(() => {
        const fetchData = async () => {
            await getDepartments();
            setLoading(false);
        };
        fetchData();
    }, [])

    useEffect(() => {
        const departmentlist = departments && departments.map(item => ({
            value: item.id,
            label: item.name,
        }));

        if (departmentlist) {
            setDepartmentOptions(departmentlist.map(item => ({
                value: item.value,
                label: item.label,
            })));
        }

        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`,
            value: item.id
        }));

        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value,
                label: item.label
            })));
        }


    }, [response, departments]);

    useEffect(() => {
        if (selectedDepartment) {
            if (selectedDepartment.label === "supplier") {
                dispatch(getVendorData());
                setIsSupplierSelected(true);
            } else {
                setIsSupplierSelected(false);
            }
        }
    }, [dispatch, selectedDepartment])




    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Add User
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add User" />
                </Box>
                <Box>
                    <Paper className={classes.root}>
                        <form className={classes.form} onSubmit={handleSubmit} >
                            <Grid container spacing={3} >
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        label="Name"
                                        name="name"
                                        variant="outlined"
                                        required
                                        fullWidth
                                        value={formData.name}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        label="UserName"
                                        name="UserName"
                                        variant="outlined"
                                        fullWidth
                                        value={formData.UserName}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        label="E-mail"
                                        name="email"
                                        variant="outlined"
                                        fullWidth
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        label="Phone No."
                                        name="phoneno"
                                        variant="outlined"
                                        fullWidth
                                        value={formData.phoneno}
                                        onChange={handleInputChange}
                                        error={!!phoneError} // Show error state
                                        helperText={phoneError} // Show error message
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Select
                                        styles={customStyles}
                                        options={departmentOptions}
                                        placeholder="Select Department"
                                        isSearchable
                                        value={selectedDepartment}
                                        onChange={setSelectedDepartment}
                                        isClearable
                                        menuPlacement="auto"
                                    />
                                </Grid>
                                {isSupplierSelected && <Grid item xs={12} sm={4}>
                                    <Select
                                        styles={customStyles}
                                        options={SupplierOptions}
                                        placeholder="Select Supplier"
                                        isSearchable
                                        value={selectedSupplier}
                                        onChange={setselectedSupplier}
                                        isClearable
                                        menuPlacement="auto"
                                    />
                                </Grid>}
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={4}>
                                    <Button
                                        className={classes.button}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        startIcon={postLoading ? <CircularProgress size={20} /> : <CheckCircleIcon />}
                                        disabled={postLoading}
                                    >
                                        {postLoading ? "Saving" : "Save"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Paper>
                </Box>
            </Container>
            <ToastContainer />
        </Layout >
    )
}

export default AddUser